var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("h3", { staticClass: "text-primary" }, [
              _c("span", { staticClass: "fa fa-user" }),
              _vm._v(" " + _vm._s(_vm.role.label) + "\n            ")
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-card",
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "primary",
                                disabled: _vm.loading
                              },
                              on: { click: _vm.voltar }
                            },
                            [
                              _c("i", { staticClass: "fas fa-arrow-left" }),
                              _vm._v(" Voltar\n                        ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "primary",
                                disabled: _vm.loading
                              },
                              on: { click: _vm.adicionar }
                            },
                            [
                              _c("i", { staticClass: "fas fa-plus" }),
                              _vm._v(
                                " Adicionar Regra\n                        "
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "text-right" },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.loading
                              },
                              on: { click: _vm.salvar }
                            },
                            [
                              _c("i", { staticClass: "fas fa-save" }),
                              _vm._v(" Salvar\n                        ")
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "mt-3" },
                    [_c("b-col", [_c("h3", [_vm._v("Permissões do grupo")])])],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.loading
                    ? _c(
                        "b-row",
                        { staticClass: "ml-3" },
                        _vm._l(_vm.persCadastroOrdenado, function(perm) {
                          return _c(
                            "b-col",
                            { key: perm.id, staticClass: "col-md-4" },
                            [
                              _c(
                                "b-form-checkbox",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip.hover.lefttop",
                                      value: perm.name,
                                      expression: "perm.name",
                                      modifiers: { hover: true, lefttop: true }
                                    }
                                  ],
                                  model: {
                                    value: perm.checked,
                                    callback: function($$v) {
                                      _vm.$set(perm, "checked", $$v)
                                    },
                                    expression: "perm.checked"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(perm.label) +
                                      "\n                        "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _c(
                        "b-row",
                        { staticClass: "text-primary" },
                        [
                          _c("b-col", { staticClass: "text-center" }, [
                            _c(
                              "b",
                              [
                                _c("b-spinner", {
                                  attrs: { label: "Spinning" }
                                }),
                                _vm._v(
                                  " Carregando Permissões...\n                        "
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { title: "Adicionar Regra" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.loading
                      },
                      on: { click: _vm.adicionarRegra }
                    },
                    [_vm._v("\n                Salvar\n            ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "secondary",
                        disabled: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          _vm.modalRegra = false
                        }
                      }
                    },
                    [_vm._v("\n                Fechar\n            ")]
                  )
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.modalRegra,
            callback: function($$v) {
              _vm.modalRegra = $$v
            },
            expression: "modalRegra"
          }
        },
        [
          _c(
            "b-form-group",
            { attrs: { label: "Nome", description: "Exemplo: listar_regras" } },
            [
              _c("b-form-input", {
                model: {
                  value: _vm.regra.name,
                  callback: function($$v) {
                    _vm.$set(_vm.regra, "name", $$v)
                  },
                  expression: "regra.name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-form-group",
            {
              attrs: { label: "Label", description: "Exemplo: Listar Regras" }
            },
            [
              _c("b-form-input", {
                model: {
                  value: _vm.regra.label,
                  callback: function($$v) {
                    _vm.$set(_vm.regra, "label", $$v)
                  },
                  expression: "regra.label"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b91f3ac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b91f3ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/Permissoes.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3b91f3ac","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/util/Permissoes.vue
// module chunks = 2